const modelTruckValidation = {
    required: 'Pole model jest wymagane',
    maxLength: {
        value: 25,
        message: 'Pole model dopuszcza maksymalnie 25 znaków',
    },
    pattern: {
        value: /.{1,}/,
        message: 'Wybierz poprawny model z listy',
    }
}

export default modelTruckValidation